const isHelpString = (searchString: string): boolean => {
    return searchString.startsWith('?') || searchString.endsWith('?')
}

export default isHelpString
